<template>
    <div class="flats-crm-card-img">
        <button class="btn-close-flats-crm-card-img" @click="closeLoopCardImg()"><svgIcon name="close" class="icon-close"/></button>
        <div class="card-img" v-if="cardData != null">
            <div class="img-in" v-if="cardData.length > 0">
                <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" v-for="(pic, index) in cardData.filter(item => item.typeCode === '1')" :key="index">
            </div>
        </div>
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-CRM-card-img',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            cardData: 'loadCardImgWindowData',
            ucoCRMurl: 'loadUrlCRMuco',
			// gridView: 'loadLandFlatsGridView',
        }),
        methods: {
            closeLoopCardImg() {
                this.$store.commit('setVisibleCardImgWindow', false);
                this.$store.commit('setCardImgData', null);
                window.body.removeClass('overflowTrue');
                document.getElementById('header').classList.remove('notvisible');
                document.getElementById('footer').classList.remove('notvisible');
                if (this.banerTopCoockieVisible == true) {
                    document.getElementById('banerTopHorizont').classList.remove('notvisible');
                }
            },
            // setGridView(param) { 
			// 	this.$store.commit('gridViewFlatsCardSet', param);
            // },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-card-img.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-card-img-respond.scss';
    // @import '@/styles/components/flats-crm/respond/flats-crm-btns-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-flats-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>